import { TranslateService } from '@ngx-translate/core';
import { DateTime } from 'luxon';
import { Notification, NotificationData } from './notification.model';

export class TelemedNotification extends Notification {
  constructor(
    data: NotificationData,
    private readonly translateService: TranslateService,
  ) {
    super(data);
    const dateDifference = DateTime.fromISO(this.sentDate).diffNow(['days', 'hours', 'minutes']);
    if (dateDifference.hours < 0) {
      this.description = this.translateService.instant('telemed_booking_of_date', { date: this.sentDate });
    } else if (dateDifference.hours <= 12) {
      this.description = this.translateService.instant('telemed_booking_description', {
        hours: dateDifference.hours,
        minutes: dateDifference.minutes,
      });
    } else if (dateDifference.hours <= 24) {
      this.description = this.translateService.instant('telemed_booking_for_tomorrow');
    } else {
      this.description = this.translateService.instant('telemed_booking_days_description', {
        days: dateDifference.days,
      });
    }
    this.actionName = this.translateService.instant('view');
    this.actionRequired = dateDifference.hours > 0;
  }
}
